import BaseUser from "@/project/model/base/BaseUser";

export default class CategoryModel extends BaseUser {
    id = 0;
    type = 0;
    name = '';
    remark = '';
    typeName = '';
}